/**
 * «Failed to fetch» names the layer that gave up, never the reason.
 *
 * Inside the shells every request leaves through the local proxy, which picks
 * the path to the server — direct, or through a relay. When that fails, the
 * page sees one opaque browser error, and a tester on the other side of the
 * world sends a screenshot that says nothing (03.09.2026: «Failed to fetch»
 * on a phone whose ISP blocks the direct path while «Только через реле» was
 * on, so no path was left at all).
 *
 * The proxy knows. This turns its state into the sentence the person needs.
 */
export function describeNetFailure(status) {
  if (!status || !status.proxy) return 'нет связи с сервером';
  const paths = status.paths || {};
  const live = Object.values(paths).reduce((n, p) => n + (p.live || 0), 0);
  const moved = Object.values(paths).some(p => (p.up || 0) + (p.down || 0) > 0);
  const where = status.lastPath && status.lastPath !== '—' ? status.lastPath : null;

  if (status.relayOnly && (where === 'нет пути' || !moved)) {
    return 'нет связи: включено «Только через реле», а ни одно реле не отвечает. '
      + 'Выключите этот переключатель в «Сервер и реле» — тогда приложение сможет пойти напрямую.';
  }
  if (where === 'нет пути') return 'нет связи: ни один путь к серверу не открылся — ни прямой, ни через реле';
  if (where) return `нет связи (последний путь: ${where}${live ? '' : ', сейчас соединений нет'})`;
  return 'нет связи с сервером';
}

/** Ask the shell what its proxy is doing; `null` in a plain browser. */
export function proxyStatus(win = typeof window === 'undefined' ? null : window) {
  try {
    const raw = win && win.VoxioxNative && win.VoxioxNative.relayStatus && win.VoxioxNative.relayStatus();
    return raw ? JSON.parse(raw) : null;
  } catch (e) { return null; }
}

/** True for the browser's «the request never happened» error. */
export function isNetworkError(e) {
  return !!e && (e.name === 'TypeError' || /failed to fetch|load failed|network(error| request failed)/i.test(e.message || ''));
}
